/**
 * Configuración responsive
 */
export const RESPONSIVE_CONFIG = {
  DIALOG: {
    maxWidth: { xs: '95%', sm: '90%', md: '80%' },
    margin: { xs: '8px', sm: '16px', md: '32px' },
  },
  FORM: {
    padding: { xs: '15px', sm: '25px', md: '35px' },
    spacing: { xs: 1, sm: 2, md: 3 },
  },
  FIELDS: {
    marginTop: { xs: '8px', sm: '12px' },
    fontSize: { xs: '14px', sm: '16px' },
    width: { xs: '100%', sm: '48%', md: '30%' },
    marginBottom: { xs: 2, md: 0 },
    buttonPadding: { xs: '8px', sm: '12px 16px' },
  },
  HEADER: {
    padding: { xs: '8px', sm: '16px' },
    titleFontSize: { xs: '20px', sm: '24px', md: '32px' },
    buttonFontSize: { xs: '14px', sm: '16px' },
    buttonPadding: { xs: '6px 16px', sm: '6px 24px' },
  },
  TYPOGRAPHIES: {
    containerDirection: { xs: 'column', sm: 'row' },
    fieldGap: { xs: 1, sm: 0 },
    titleFontSize: { xs: '18px', md: '24px' },
    inputFontSize: { xs: '14px', md: '16px' },
  },
};

/**
 * Configuración de animaciones
 */
export const ANIMATIONS = {
  FADE_IN: {
    animation: 'fadeIn 0.5s ease-in-out',
    '@keyframes fadeIn': {
      '0%': {
        opacity: 0,
        transform: 'translateX(20px)',
      },
      '100%': {
        opacity: 1,
        transform: 'translateX(0)',
      },
    },
  },
  FADE_IN_DELAYED: (delay = '0.1s') => ({
    animation: 'fadeIn 0.5s ease-in-out',
    animationDelay: delay,
    animationFillMode: 'both',
    '@keyframes fadeIn': {
      '0%': {
        opacity: 0,
        transform: 'translateX(20px)',
      },
      '100%': {
        opacity: 1,
        transform: 'translateX(0)',
      },
    },
  }),
};

/**
 * Estilos de campos comunes
 */
export const FIELD_STYLES = {
  BASE: {
    mr: 0.5,
    ml: 0.5,
    '& .MuiInputBase-input': {
      fontSize: { xs: '14px', md: '16px' },
    },
  },
  FLEX_NORMAL: (showDifferenceColumn) => ({
    mr: 0.5,
    ml: 0.5,
    flex: showDifferenceColumn ? 1 : 1.5,
    '& .MuiInputBase-input': {
      fontSize: { xs: '14px', md: '16px' },
    },
  }),
  FLEX_FULL: {
    mr: 0.5,
    ml: 0.5,
    flex: 1,
    '& .MuiInputBase-input': {
      fontSize: { xs: '14px', md: '16px' },
    },
  },
};

/**
 * Configuración de íconos
 */
export const ICONS_CONFIG = {
  WHITESMOKE: {
    color: 'whitesmoke',
    fontSize: { xs: '20px', sm: '24px' },
  },
  BASE: {
    fontSize: { xs: '20px', md: '24px' },
  },
  BIG: {
    fontSize: { xs: '25px', md: '29px' },
  },
  SMALL: {
    fontSize: { xs: '16px', md: '20px' },
  },
};
